@if (isLoading) {
  <p-progressBar mode="indeterminate" [style]="{ height: '6px' }"></p-progressBar>
}

@if (!isLoading) {
  <div class="wrapper">
    <div class="breadcrumb-container">
      <p-breadcrumb [model]="breadcrumbItems" styleClass="breadcrumb" />
    </div>
    <div class="snapshot-container">
      <app-patient-snapshot></app-patient-snapshot>
    </div>
    @if (!isLoading) {
      <div class="other-info-container">
        <p-tabs [value]="currentMainTabValue" (valueChange)="onMainTabChange($event)">
          <p-tablist>
            <p-tab value="0">Patient Charting</p-tab>
            <p-tab value="1">Vital Signs</p-tab>
            <p-tab value="2">Provider Charts</p-tab>
            <p-tab value="3">MAR</p-tab>
            <p-tab value="4">Document</p-tab>
            <p-tab value="5">Care Plan</p-tab>
          </p-tablist>
          <p-tabpanels>
            <p-tabpanel value="0">
              <!-- Secondary row of tabs under Patient Charting -->
              <p-tabs value="0">
                <p-tablist>
                  <p-tab value="0">Nursing Assessment</p-tab>
                  <p-tab value="1">Assessment History</p-tab>
                </p-tablist>
                <p-tabpanels>
                  <p-tabpanel value="0">
                    <app-assessments-tab> </app-assessments-tab>
                  </p-tabpanel>
                  <p-tabpanel value="1">
                    <app-assessments-history-tab> </app-assessments-history-tab>
                  </p-tabpanel>
                </p-tabpanels>
              </p-tabs>
            </p-tabpanel>
            <p-tabpanel value="1">
              <app-vitals-tab></app-vitals-tab>
            </p-tabpanel>
            <p-tabpanel value="2">
              <app-provider-charts-tab></app-provider-charts-tab>
            </p-tabpanel>
            <p-tabpanel value="3">
              <app-mar-tab></app-mar-tab>
            </p-tabpanel>
            <p-tabpanel value="4">
              <app-upload-tab></app-upload-tab>
            </p-tabpanel>
            <p-tabpanel value="5">
              <app-care-plan-tab></app-care-plan-tab>
            </p-tabpanel>
          </p-tabpanels>
        </p-tabs>
      </div>
    }
  </div>
}